<section>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-9">
          <app-event-configurator #eventConfigurator></app-event-configurator>
        </div>
        <div class="col-3 ticket">
          <!-- <app-bookin-basket-simple-view></app-bookin-basket-simple-view> -->
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-9">
          <app-backward-forward (backwardClick)="onBackwardClick()" (forwardClick)="onForwardClick()" [forwardError]="forwardError"></app-backward-forward>
        </div>
        <div class="col-3 ticket">
        </div>
      </div>
    </div>
  </section>
